import { ViewModel, View } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class MachineModelSelectorViewModel extends SelectorBaseViewModel<MachineModel> {
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }

    protected async loadData(): Promise<MachineModel[]> {
        let result = await ServerConnection.callServer('/Complex/MachineModelServices/ListAllMachineModels', {})
        return result.MachineModels.map(x => {
            let m = new MachineModel(this);
            m.id = x.Id;
            m.title = `${x.Name} (${x.Code})`;
            return m;
        });
    }
}

export class MachineModel extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title; } private _title: string;
}